import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {PossessedGameMode} from "../../server/PossessedGameMode";
import {PossessedSymbol, PossessedSymbolStates} from "../../reels/PossessedSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import { PossessedActivatorSymbol } from "../../reels/PossessedActivatorSymbol";

export class XActivatorPresentation extends SimplePresentation {

    constructor() {
        super("xActivatorPresentation");
    }

    public override shouldRun(): boolean {
        return Possessed.model.getActivationSymbol().length > 0 && !Possessed.model.triggeredFreespins()
            && !Possessed.model.gameData.brokeTheBank;
    }

    buildTimeline() {
        const tl = this.tl;

        // Show crucifix reel if we just triggered respin
        if(Possessed.model.triggeredRespin()) {
            tl.add(Possessed.crucifixReel.fadeIn(5));
        }
        const activators = Possessed.model.getActivationSymbol();
        // Update hotzones
        activators.forEach(pos => {
            const symbol = <PossessedActivatorSymbol>Possessed.reelView.getSymbolAt(pos.reelID, pos.reelPosition);

            tl.add(symbol.activate());
            tl.add(() => {
                Possessed.soundPlayer.playSound("xactWoosh");
            }, "<")
            tl.add(Possessed.crucifixReel.shootFireball(symbol.getAbsolutePosition(), Possessed.crucifixReel.getCurrentLevel()));
            tl.add(Possessed.crucifixReel.increaseLevel(), "<");
            tl.add(() => {
                const removeSound = Possessed.crucifixReel.getCurrentLevel() == 4 ? "xcruRemoveFirst" : "xcruRemoveSequent";
                Possessed.soundPlayer.playSound(removeSound);
            }, "<0.35")
        })

        tl.add(() => {
            Possessed.soundPlayer.stopSound("xcruHighlight");
        })

        const hotZoneCount = Possessed.model.data.nextHotZoneSize;
        tl.add(Possessed.reelView.reelCross.updateHotZones(hotZoneCount), "<");
    }
}